import Content from '../types/enums/content';
import Event from './event';
import { IEPGEventRequest } from '../types/interfaces/event';

class EpgEvent extends Event {
  channelId: string;
  lowPoster?: string;
  genreId: string | { name: string; titles: { [key: string]: string } };
  seasonCode?: string | undefined;
  seasonId?: string;
  constructor(request: IEPGEventRequest) {
    super({ ...request, type: Content.EPG_EVENT });
    this.channelId = request.channel;
    this.genreId = request?.gender || '';
    this.lowPoster = this.poster + '?width=1';
    this.seasonCode =
      request.seasonId && request.channelName
        ? `S_${request.seasonId}-${request.channelName}`
        : undefined;
    this.seasonId = request?.seasonId;
  }
}

export default EpgEvent;
